export const addTempSensor = (isBloodComm) => {
	if(isBloodComm){
		return 'Add Blood Cooler'
	}
	return 'Add Temperature Sensor'
};
export const tempSensors = (isBloodComm) => {
	if(isBloodComm){
		return 'Blood Coolers'
	}
	return 'Temperature Sensors'
};

export const temperatureSensor = (isBloodComm) => {
	if(isBloodComm){
		return 'Blood Cooler'
	}
	return 'Temperature Sensor'
};



// WEBPACK FOOTER //
// ./src/utils/tempSensorVerbage.js